type Props = {
  currentQuestion: any;
};
const AddressField = ({ currentQuestion }: Props) => {
  const addressData = currentQuestion?.responses?.[0]?.addressData;

  const properties = currentQuestion?.properties;

  if (!addressData || !properties) return null;

  return (
    <ul style={{ listStyle: "none", padding: 0 }}>
      {properties.zipcode && addressData.zipcode && (
        <li>
          <span style={{ fontWeight: 500 }}>Zip Code:</span>{" "}
          {addressData.zipcode}
        </li>
      )}

      {properties.city && addressData.city && (
        <li>
          <span style={{ fontWeight: 500 }}>City:</span> {addressData.city}
        </li>
      )}

      {properties.state && addressData.state && (
        <li>
          <span style={{ fontWeight: 500 }}>State:</span> {addressData.state}
        </li>
      )}

      {properties.country && addressData.country && (
        <li>
          <span style={{ fontWeight: 500 }}>Country:</span>{" "}
          {addressData.country}
        </li>
      )}
    </ul>
  );
};

export default AddressField;
